import { Build, Component, Element, h, Host } from '@stencil/core';

@Component({
    tag: 'app-diagram',
    shadow: true
})
export class AppDiagramComponent {
    static lib?: typeof import('mermaid').default;

    @Element() element!: HTMLElement;

    content?: string;
    style?: string;

    async componentWillRender() {
        this.style = (await import('./component.css')).default;

        if (AppDiagramComponent.lib === undefined) {

            const mermaid = (await import('mermaid')).default;
            mermaid.initialize({
                startOnLoad: false,
                theme: 'default',
                fontFamily: 'Arial',
                sequence: {
                    diagramMarginX: 0,
                    diagramMarginY: 0,
                    mirrorActors: false,
                    bottomMarginAdj: 20,
                    messageFontSize: 18,
                    actorFontSize: 15
                }
            });

            AppDiagramComponent.lib = mermaid;
        }

        const code = this.element.textContent ?? 'no diagram code';
        this.element.textContent = '';

        const result = await AppDiagramComponent.lib.render('diagram', code);

        const element = document.createElement('div');
        element.innerHTML = result.svg;

        this.content = this.clean(element)!.innerHTML;
    }

    render() {
        return <Host>
            <style>{this.style}</style>
            <p class="header">
                <span class="title">{this.element.title}</span>
            </p>
            <div innerHTML={this.content}></div>
        </Host>;
    }

    clean(element: Element): Element | undefined {
        if (element.tagName === 'style')
            return undefined;

        element.removeAttribute('style');
        element.removeAttribute('fill');
        element.removeAttribute('stroke');
        element.removeAttribute('stroke-width');
        element.removeAttribute('stroke-dasharray');
        element.removeAttribute('text-anchor');
        element.removeAttribute('font');
        element.removeAttribute('font-size');
        element.removeAttribute('font-weight');

        if (element.id.startsWith('actor'))
            element.classList.add('actorLine');

        if (element.tagName === 'tspan')
            element.removeAttribute('x');

        let x = 0;

        Array
            .from(element.children)
            .forEach(child => {

                const cleaned = this.clean(child);
                element.removeChild(child);

                if (cleaned === undefined)
                    return;

                if (x === 0
                    && cleaned.classList.contains('loopLine'))
                    x = Number.parseInt(cleaned.getAttribute('x2')!) - 20;

                if (x !== 0
                    && cleaned.classList.contains('loopText'))
                    cleaned.setAttribute('x', `${x}`);

                if (!Build.isBrowser
                    && cleaned.classList.contains('messageText'))
                    cleaned.setAttribute('y', `${Number.parseInt(cleaned.getAttribute('y')!) - 18}`);

                element.appendChild(cleaned);
            });

        return element;
    }
}
